// extracted by mini-css-extract-plugin
module.exports = {"guess":"Replay_guess__B2PxP"};